"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
const moment_1 = __importDefault(require("moment"));
const lodash_1 = require("lodash");
const c = __importStar(require("../constants/calendar"));
// Checks if the current event is currently happening
exports.isEventActive = (startTime, endTime) => {
    if (!(lodash_1.isNumber(startTime) && lodash_1.isNumber(endTime)))
        return false;
    const now = moment_1.default().unix();
    return now >= startTime && now < endTime;
};
// Returns true when it is the specified number of minutes before an event's start time
exports.isUpcomingEvent = (startTime, endTime, minutes) => {
    if (!(lodash_1.isNumber(startTime) && lodash_1.isNumber(endTime)))
        return false;
    const now = moment_1.default().unix();
    const seconds = moment_1.default.duration(minutes, 'minutes').asSeconds();
    return now >= startTime - seconds && now < endTime;
};
// Format datetime to human-readable form
// Example result: 1:00 PM
exports.formatTime = (epoch) => {
    if (!lodash_1.isNumber(epoch))
        return '';
    return moment_1.default.unix(epoch).format('h:mm A');
};
exports.setCalendarEvents = events => {
    if (!(events && lodash_1.isArray(events) && lodash_1.isFunction(events.forEach)))
        return [];
    events.forEach(
    // for each event do the following:
    // 1: add a new prop isActive that indicates if the event is currently happening
    // 2. add a new prop isUpcoming that indicates if the event will occur in the near future
    // 3: format the time of each event to human-readable form
    e => {
        var _a, _b, _c, _d, _e, _f;
        e.isActive = exports.isEventActive((_a = e) === null || _a === void 0 ? void 0 : _a.starttime, (_b = e) === null || _b === void 0 ? void 0 : _b.endtime);
        e.isUpcoming = exports.isUpcomingEvent((_c = e) === null || _c === void 0 ? void 0 : _c.starttime, (_d = e) === null || _d === void 0 ? void 0 : _d.endtime, 15); // Is event coming up in 15 minutes
        e.formattedStartTime = exports.formatTime((_e = e) === null || _e === void 0 ? void 0 : _e.starttime);
        e.formattedEndTime = exports.formatTime((_f = e) === null || _f === void 0 ? void 0 : _f.endtime);
    });
    return events;
};
// Get the calendar events that will occur in the current day
exports.getCalendarTodayEvents = (schedule) => {
    if (lodash_1.isEmpty(schedule))
        return [];
    // Start and end of day in Unix timestamp
    const startOfDay = moment_1.default()
        .startOf('day')
        .unix();
    const endOfDay = moment_1.default()
        .endOf('day')
        .unix();
    const todayItems = schedule.filter((item) => {
        var _a, _b, _c, _d;
        const startTime = (_b = (_a = item) === null || _a === void 0 ? void 0 : _a.starttime, (_b !== null && _b !== void 0 ? _b : c.EVENT_TIME_DEFAULT));
        const endTime = (_d = (_c = item) === null || _c === void 0 ? void 0 : _c.endtime, (_d !== null && _d !== void 0 ? _d : c.EVENT_TIME_DEFAULT));
        return (startTime >= startOfDay &&
            startTime < endOfDay && // event is today
            endTime > moment_1.default().unix()); // event has not ended yet
    });
    const formattedSchedule = todayItems.sort((a, b) => {
        var _a, _b, _c, _d, _e, _f;
        const aIsActive = (_b = (_a = a) === null || _a === void 0 ? void 0 : _a.isActive, (_b !== null && _b !== void 0 ? _b : false));
        const bIsActive = (_d = (_c = b) === null || _c === void 0 ? void 0 : _c.isActive, (_d !== null && _d !== void 0 ? _d : false));
        const aStartTime = (_e = a.starttime, (_e !== null && _e !== void 0 ? _e : c.EVENT_TIME_DEFAULT));
        const bStartTime = (_f = b.starttime, (_f !== null && _f !== void 0 ? _f : c.EVENT_TIME_DEFAULT));
        if (aIsActive && !bIsActive) {
            // active event comes first
            return -1;
        }
        else if (!aIsActive && bIsActive) {
            // active event comes first
            return 1;
        }
        else if (aIsActive && bIsActive) {
            // sort active events by latest start time
            return bStartTime - aStartTime;
        }
        else {
            // sort inactive events by earliest start time
            return aStartTime - bStartTime;
        }
    });
    return formattedSchedule;
};
// Get the calendar events that will happen the next day
exports.getCalendarTomorrowEvents = (schedule) => {
    if (lodash_1.isEmpty(schedule))
        return [];
    // Start and end of day in Unix timestamp
    const startOfTomorrow = moment_1.default()
        .startOf('day')
        .add(1, 'days')
        .unix();
    const endOfTomorrow = moment_1.default()
        .endOf('day')
        .add(1, 'days')
        .unix();
    const tomorrowItems = schedule.filter((item) => {
        var _a, _b;
        const startTime = (_b = (_a = item) === null || _a === void 0 ? void 0 : _a.starttime, (_b !== null && _b !== void 0 ? _b : c.EVENT_TIME_DEFAULT));
        return startTime >= startOfTomorrow && startTime < endOfTomorrow; // event is tomorrow only
    });
    const formattedSchedule = tomorrowItems.sort((a, b) => {
        var _a, _b, _c, _d;
        const aStartTime = (_b = (_a = a) === null || _a === void 0 ? void 0 : _a.starttime, (_b !== null && _b !== void 0 ? _b : c.EVENT_TIME_DEFAULT));
        const bStartTime = (_d = (_c = b) === null || _c === void 0 ? void 0 : _c.starttime, (_d !== null && _d !== void 0 ? _d : c.EVENT_TIME_DEFAULT));
        return aStartTime - bStartTime; // earliest event comes first
    });
    return formattedSchedule;
};
// Get the calendar events that are currently happening
exports.getCalendarActiveEvents = (events) => {
    if (lodash_1.isEmpty(events))
        return [];
    const activeEvents = events.filter(e => e.isActive);
    return activeEvents;
};
exports.updateCalendarEvents = (store, events) => {
    if (events !== null && events !== undefined) {
        store.dispatch({ type: c.CALENDAR_UPDATE, payload: events });
    }
};



//////////////////
// WEBPACK FOOTER
// ./node_modules/@lifesize/clients.remoting/dist/utils/calendar.js
// module id = 154
// module chunks = 0